import React from 'react';

const RefundPolicy: React.FC = () => {
  return (
    <div style={{
      fontFamily: '"Helvetica Neue", sans-serif',
      background: '#fefefe',
      color: '#212121',
      margin: 0,
      padding: 0,
      minHeight: '100vh'
    }}>
      <div className="policy-page-inner" style={{
        maxWidth: '880px',
        margin: '20px auto',
        padding: '24px',
        background: '#ffffff',
        borderRadius: '10px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
      }}>
        <h1 style={{
          textAlign: 'center',
          color: '#0C7B3D',
          fontSize: '2em',
          marginBottom: '1em'
        }}>
          Refund Policy
        </h1>
        <p style={{ textAlign: 'center', fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Last Updated: January 16, 2026
        </p>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          <strong>JEJELY ULTIMATE LIMITED</strong> is committed to providing fair and transparent refund practices for all our customers. This refund policy outlines the circumstances under which refunds may be processed and the procedures for requesting them.
        </p>
        
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          By using our services, you acknowledge that you have read, understood, and agree to be bound by this refund policy. We reserve the right to modify this policy at any time without prior notice.
        </p>

        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          1. Refund Eligibility
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Refunds may be considered in the following circumstances:
        </p>
        <ul style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em', paddingLeft: '20px' }}>
          <li><strong>Duplicate Payments:</strong> When duplicate payments are made by mistake through our system</li>
          <li><strong>Overpayments:</strong> When payments exceed the loan amount and applicable interest charges</li>
          <li><strong>Technical Errors:</strong> When technical errors result in incorrect charges or deductions</li>
          <li><strong>Service Issues:</strong> When services are not provided as agreed upon in the loan agreement</li>
          <li><strong>Regulatory Compliance:</strong> When refunds are required due to regulatory compliance issues</li>
          <li><strong>Processing Errors:</strong> When administrative or processing errors occur on our part</li>
        </ul>
        
        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          2. Refund Process
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          To request a refund, please follow these steps:
        </p>
        <ul style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em', paddingLeft: '20px' }}>
          <li><strong>Contact Customer Service:</strong> You can reach us via Phone, Email, or WhatsApp.</li>
          <li><strong>Provide Documentation:</strong> Submit detailed explanation and supporting documentation for your refund request</li>
          <li><strong>Review Period:</strong> Our team will review your request within one week.</li>
          <li><strong>Processing:</strong> Refunds will be processed to the original payment method used</li>
        </ul>

        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          3. Non-Refundable Items
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          The following items are generally not eligible for refunds:
        </p>
        <ul style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em', paddingLeft: '20px' }}>
          <li><strong>Interest Charges:</strong> Interest charges on loans as per the agreed terms</li>
          <li><strong>Processing Fees:</strong> Processing fees for completed transactions</li>
          <li><strong>Late Payment Penalties:</strong> Penalties incurred due to late payments</li>
          <li><strong>Services Rendered:</strong> Services that have already been provided</li>
          <li><strong>Administrative Fees:</strong> Administrative fees for loan processing and management</li>
          <li><strong>Third-Party Charges:</strong> Charges imposed by third-party service providers</li>
        </ul>

        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          4. Refund Methods
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          Approved refunds will be processed using the following methods:
        </p>
        <ul style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em', paddingLeft: '20px' }}>
          <li><strong>Original Payment Method:</strong> Refunds will be credited back to the original payment method</li>
          <li><strong>Bank Transfer:</strong> For bank transfers, refunds will be processed to the originating account</li>
          <li><strong>Mobile Money:</strong> For mobile money payments, refunds will be processed to the originating wallet</li>
          <li><strong>Processing Time:</strong> Refund processing time may vary depending on the payment method</li>
        </ul>

        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          5. Dispute Resolution
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          If you are not satisfied with our refund decision, you may:
        </p>
        <ul style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em', paddingLeft: '20px' }}>
          <li><strong>Appeal Process:</strong> Submit an appeal with additional supporting documentation</li>
          <li><strong>Escalation:</strong> Request escalation to our management team for review</li>
        </ul>

        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          6. Policy Updates
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
          We reserve the right to modify this refund policy at any time. Changes will be posted on our website and will become effective immediately upon posting. It is your responsibility to review this policy periodically to stay informed of any updates.
        </p>

        <h2 style={{
          color: '#F4B400',
          marginTop: '2em',
          borderLeft: '5px solid #0C7B3D',
          paddingLeft: '12px'
        }}>
          7. Contact Information
        </h2>
        <div style={{
          background: '#e6f5ec',
          padding: '15px',
          borderLeft: '4px solid #0C7B3D',
          margin: '1.5em 0',
          borderRadius: '5px'
        }}>
          <strong>Company: JEJELY ULTIMATE LIMITED</strong><br/>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em' }}>
            For refund requests or questions about this policy, please contact us:
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', marginBottom: '0.9em', paddingLeft: '20px' }}>
            <li><strong>Email:</strong> <a href="mailto:fairlonerhelp@gmail.com" style={{ color: '#0C7B3D', textDecoration: 'underline' }}>fairlonerhelp@gmail.com</a></li>
            <li><strong>Phone:</strong> 08158120510</li>
            <li><strong>Business Hours:</strong> Monday - Sunday: 8:00 AM - 6:00 PM</li>
          </ul>
        </div>

        <div style={{
          textAlign: 'center',
          color: '#666',
          fontSize: '0.9em',
          marginTop: '50px'
        }}>
          ©.2025 JEJELY ULTIMATE LIMITED. Made for Nigeria.
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
